/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 01/02/2022 08:20
 */
import { HighlightLegend } from './highlight-legend';
import { HighlightDots } from './highlight-dots';
import { Dayjs } from 'dayjs';
import { CommonUtils } from '../../tool/common-utils';

/**
 * Representation of Datepicker cell
 */
export class DatePickerDay {
  public get id(): string {
    return `${this.day}-${this.month}-${this.year}`;
  }

  public day: number;
  public month: number;
  public year: number;
  public date: Date;
  public status: 'disabled' | 'hidden' | 'enabled' | 'out' = 'enabled';
  public backgroundColor: string;
  public borderColor: string;
  public color: string;

  public dots: HighlightDots[];
  current: boolean;

  public static fromDate(date: Dayjs): DatePickerDay {
    return new DatePickerDay(date.date(), date.month(), date.year());
  }

  constructor(
    day: number,
    month: number,
    year: number,
    status?: 'disabled' | 'hidden' | 'enabled' | 'out',
  ) {
    this.day = day;
    this.month = month;
    this.year = year;
    if (status) {
      this.status = status;
    }
    this.date = new Date(year, month, day);
    this.current = CommonUtils.isToday(new Date(year, month, day));
    this.dots = [];
  }

  public addDot(legend: HighlightLegend) {
    let dot: HighlightDots;
    if (!(legend instanceof HighlightDots)) {
      dot = new HighlightDots(legend.name, legend.backgroundColor);
    } else {
      dot = legend;
    }
    if (!this.dots.find((d) => d.equals(dot))) {
      this.dots.push(dot);
    }
  }

  public toString(): string {
    return this.day + '';
  }
}
